import React, { useState } from 'react';

import { useLocation } from 'hooks/useLocation';

import { CommentBox } from './CommentBox';
import { Mentions } from './MentionsEditor';

interface Props {
  belongsToAuthUser?: boolean;
  canApprove?: boolean;
  discussion?: MorressierDiscussion;
  replies?: {
    belongsToAuthUser: boolean;
    discussion: MorressierDiscussion;
    authorChip?: string | undefined;
  }[];
  authorChip?: string | undefined;
  handleReply?: (
    parent_id: string,
    message: string,
    rawMessage: string,
    mentionedUsers: string[],
  ) => Promise<boolean>;
  handleDelete?: (id: string) => Promise<boolean>;
  mentions: Mentions[];
  canUserPostComment: boolean;
}

export const Comment: React.FC<Props> = props => {
  const {
    belongsToAuthUser,
    canApprove,
    discussion,
    replies,
    handleReply,
    handleDelete,
    authorChip,
    mentions,
    canUserPostComment,
  } = props;

  const origin = useLocation()?.origin;
  const [isApproved, setIsApproved] = useState(!!discussion?.approved_at);

  if (!discussion) return null;

  return (
    <CommentBox
      authorChip={authorChip}
      belongsToAuthUser={belongsToAuthUser}
      canApprove={canApprove}
      discussion={discussion}
      hasReply={replies && replies.length > 0}
      handleReply={handleReply}
      handleDelete={handleDelete}
      mentions={mentions}
      isApproved={isApproved}
      setIsApproved={setIsApproved}
      canUserPostComment={canUserPostComment}
    >
      {replies?.map(reply => (
        <CommentBox
          key={reply.discussion.id}
          authorChip={reply.authorChip}
          belongsToAuthUser={reply.belongsToAuthUser}
          discussion={reply.discussion}
          isReply
          handleDelete={handleDelete}
          handleReply={handleReply}
          replyTo={{
            threadId: discussion.id,
            name: reply.discussion.author?.full_name || '',
            id: reply.discussion.author?._id || '',
            link: `${origin}/profile/${reply.discussion.author?._id}`,
            avatar: reply.discussion.author?.picture_url,
            department: reply.discussion.author?.department,
            organization: reply.discussion.author?.organization,
          }}
          mentions={mentions}
          isApproved={isApproved}
          setIsApproved={setIsApproved}
          canUserPostComment={canUserPostComment}
        />
      ))}
    </CommentBox>
  );
};
